import { render } from "./CabinType.vue?vue&type=template&id=65304a2d"
import script from "./CabinType.vue?vue&type=script&lang=js"
export * from "./CabinType.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__